import { uploadFileToStorage } from "@/service/api/admin-attachments";
import { AdminKnowledgeBaseService } from "@/service/api/admin-knowledge-base";

export interface UploadedMedia {
  key: string;
  url: string;
}

export interface MediaUploadOptions {
  onProgress?: (percent: number) => void;
}

export type MediaUploader = (file: File, options?: MediaUploadOptions) => Promise<UploadedMedia>;

export const uploadKnowledgeBaseMedia: MediaUploader = async (file, options) => {
  const generated = await AdminKnowledgeBaseService.generateUploadUrl({ fileName: file.name, mimeType: file.type });
  await uploadFileToStorage(generated.uploadUrl, file, { onProgress: options?.onProgress });
  return AdminKnowledgeBaseService.confirmUpload({ id: generated.attachmentId });
};
